import { render, staticRenderFns } from "./amtChart.vue?vue&type=template&id=a8933728&scoped=true"
import script from "./amtChart.vue?vue&type=script&lang=js"
export * from "./amtChart.vue?vue&type=script&lang=js"
import style0 from "./amtChart.vue?vue&type=style&index=0&id=a8933728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8933728",
  null
  
)

export default component.exports